import { openapiClient, unwrapResult } from '@/api/openapi-client';
import { orderKeys } from '@/features/orders/hooks/queryKeys';
import { useRestaurantStore } from '@/stores/restaurant.store';
import type { AwaitingPaymentOrderList } from '@restaurant/api-client';
import { useQuery } from '@tanstack/react-query';

export const AWAITING_PAYMENT_REFETCH_MS = 30_000;

export function useAwaitingPaymentOrders() {
  const restaurantId = useRestaurantStore((s) => s.selectedRestaurantId);

  return useQuery({
    queryKey: orderKeys.awaitingPayment(restaurantId ?? ''),
    queryFn: async () => {
      if (!restaurantId) throw new Error('No restaurant selected');
      return unwrapResult<AwaitingPaymentOrderList>(
        await openapiClient.GET('/api/restaurants/{restaurantId}/awaiting-payment-orders', {
          params: { path: { restaurantId } },
        }),
      );
    },
    enabled: !!restaurantId,
    refetchInterval: AWAITING_PAYMENT_REFETCH_MS,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
